// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1bhXY","question":"Question_question__24rJD","description":"Question_description__2Kot7"};